import React from 'react';
import { LANGUAGES, TONES } from '../../constants/aiTools';

const inputStyle = {
  width: '100%',
  padding: '0.6rem 0.85rem',
  border: '1px solid #d1d5db',
  borderRadius: '7px',
  fontSize: '0.9rem',
  color: '#111827',
  background: '#fff',
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.2s',
};

const labelStyle = {
  display: 'block',
  fontSize: '0.85rem',
  fontWeight: 600,
  color: '#374151',
  marginBottom: '0.4rem',
};

const GenerateForm = ({ tool, formData, onChange, onSubmit, loading }) => {
  if (!tool) return null;

  return (
    <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
      {tool.fields.map((field) => (
        <div key={field.key}>
          <label style={labelStyle}>{field.label} <span style={{ color: '#ef4444' }}>*</span></label>
          {field.type === 'textarea' ? (
            <textarea
              required
              rows={4}
              placeholder={field.placeholder}
              value={formData[field.key] || ''}
              onChange={e => onChange(field.key, e.target.value)}
              style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit' }}
              onFocus={e => e.target.style.borderColor = '#16a34a'}
              onBlur={e => e.target.style.borderColor = '#d1d5db'}
            />
          ) : (
            <input
              required
              type="text"
              placeholder={field.placeholder}
              value={formData[field.key] || ''}
              onChange={e => onChange(field.key, e.target.value)}
              style={inputStyle}
              onFocus={e => e.target.style.borderColor = '#16a34a'}
              onBlur={e => e.target.style.borderColor = '#d1d5db'}
            />
          )}
        </div>
      ))}

      {tool.hasTone && (
        <div>
          <label style={labelStyle}>Tone <span style={{ color: '#ef4444' }}>*</span></label>
          <select
            required
            value={formData.tone || ''}
            onChange={e => onChange('tone', e.target.value)}
            style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#16a34a'}
            onBlur={e => e.target.style.borderColor = '#d1d5db'}
          >
            <option value="">Select tone...</option>
            {TONES.map(t => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label style={labelStyle}>Language <span style={{ color: '#ef4444' }}>*</span></label>
        <select
          required
          value={formData.language || 'English'}
          onChange={e => onChange('language', e.target.value)}
          style={inputStyle}
          onFocus={e => e.target.style.borderColor = '#16a34a'}
          onBlur={e => e.target.style.borderColor = '#d1d5db'}
        >
          {LANGUAGES.map(l => (
            <option key={l.value} value={l.value}>{l.label}</option>
          ))}
        </select>
      </div>

      <button
        type="submit"
        disabled={loading}
        style={{
          marginTop: '0.5rem',
          background: loading ? '#86efac' : '#16a34a',
          color: '#fff',
          border: 'none',
          borderRadius: '7px',
          padding: '0.75rem 2rem',
          fontSize: '0.95rem',
          fontWeight: 700,
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
          transition: 'background 0.2s',
        }}
        onMouseEnter={e => { if (!loading) e.currentTarget.style.background = '#15803d'; }}
        onMouseLeave={e => { if (!loading) e.currentTarget.style.background = '#16a34a'; }}
      >
        {loading ? (
          <>
            <span style={{
              width: '16px', height: '16px', border: '2px solid #fff',
              borderTopColor: 'transparent', borderRadius: '50%',
              display: 'inline-block', animation: 'spin 0.7s linear infinite',
            }} />
            Generating...
          </>
        ) : 'Generate'}
      </button>
    </form>
  );
};

export default GenerateForm;
